const isShareLink = (query) =>
  !!(
    query.hash ||
    query.packageShare ||
    query.voucherCode ||
    ((query.address || query.postcode) && query.housemates)
  );

const findDiscountCode = (query, store) => {
  const { offer, aff } = store.state.discount;
  if (offer && aff) {
    return `${offer}-${aff}`;
  }

  let qOfferCode = query.offer;
  let qAffiliateCode = query.aff;

  if (qOfferCode && qAffiliateCode) {
    store.commit("SET_DISCOUNT_STATE", {
      offer: qOfferCode,
      aff: qAffiliateCode,
    });

    return `${qOfferCode}-${qAffiliateCode}`;
  }

  return null;
};

export { findDiscountCode, isShareLink };
